var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRunFlatRound2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 40C31.0457 40 40 31.0457 40 20C40 8.9543 31.0457 0 20 0C8.9543 0 0 8.9543 0 20C0 31.0457 8.9543 40 20 40Z",
    fill: "#08979C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M33.3007 12.3821L31.4723 13.4344L28.3358 14.369L30.4959 11.9459L32.369 10.8123L33.3007 12.3821Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M33.2503 8.52008L34.429 10.4974L35.6078 12.4746L34.5341 13.1147L32.1768 9.16006L33.2503 8.52008Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.4798 11.0426L25.303 10.306L26.7708 7.99094C23.9976 6.41931 20.7799 5.90799 17.6473 6.47235L18.2437 9.09721L16.8816 9.39823L16.2687 6.75134C14.6697 7.19635 13.1099 7.92265 11.6999 8.98517C10.5323 9.86506 9.5913 10.9541 8.76622 12.0594L11.0426 13.5218L10.306 14.6987L7.99094 13.2308C6.41931 16.0041 5.90799 19.2218 6.47235 22.3543L9.09721 21.758L9.39823 23.1201L6.75134 23.733C7.19635 25.332 7.92265 26.8917 8.98517 28.3017C9.86506 29.4694 10.9541 30.4104 12.0594 31.2354L13.5218 28.959L14.6987 29.6957L13.2308 32.0107C16.0041 33.5824 19.2218 34.0937 22.3543 33.5293L21.758 30.9045L23.1201 30.6034L23.733 33.2503C25.332 32.8053 26.8917 32.079 28.3017 31.0165C29.4694 30.1366 30.4104 29.0476 31.2354 27.9422L28.959 26.4798L29.6957 25.303L32.0107 26.7708C33.5824 23.9976 34.0937 20.7799 33.5293 17.6473L30.9045 18.2437L30.6034 16.8816L33.2503 16.2687L31.641 14.1543L26.07 15.7243L29.766 11.5739L30.0396 11.2587L27.9422 8.76622L26.4798 11.0426ZM15.8074 27.1331C19.7354 29.458 24.8083 28.1224 27.1331 24.1943C27.6861 23.2583 28.0488 22.2223 28.2003 21.1457C28.3519 20.0692 28.2893 18.9733 28.0163 17.921C26.7708 15.8074 26.7031 16.9107 24.4399 16.8816C24.8286 15.1733 26.2079 14.4837 24.1943 12.8685C20.2663 10.5437 15.1934 11.8793 12.8685 15.8074C10.5437 19.7354 11.8793 24.8083 15.8074 27.1331Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRunFlatRound2);
export default __webpack_public_path__ + "static/media/run-flat-round-2.f7dcacd6b4855e9250e0237519bb8031.svg";
export { ForwardRef as ReactComponent };